import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Shield } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
export function FinalCTA() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-navy-primary py-12 md:py-20 px-4 md:px-6" data-id="element-96">
      <div className="max-w-4xl mx-auto text-center" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-98">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-white mb-4 md:mb-6" data-id="element-99">
            Jesteś gotowy żeby zmienić swój sposób trenowania?
          </h2>
          <p className="text-base md:text-xl text-gray-300 mb-6 md:mb-8" data-id="element-100">
            Dołącz do ponad 1 200 trenerów którzy wybrali ten system
          </p>

          <CTAButton onClick={scrollToOffer} size="large" className="mb-6 w-full sm:w-auto" data-id="element-101">
            ⚽ TAK! Chcę odzyskać swój czas i trenować piłkę nożną jak
            profesjonalista
          </CTAButton>

          <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-xs md:text-sm text-gray-300" data-id="element-102">
            <span className="flex items-center gap-1" data-id="element-103">
              <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold-accent" data-id="element-104" />
              Natychmiastowy dostęp
            </span>
            <span className="flex items-center gap-1" data-id="element-105">
              <Shield className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold-accent" data-id="element-106" />
              Gwarancja 7 dni
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}